import { useContext, useEffect, useReducer, useState } from "react";
import "./NurtureCampaignInitComp.css";
import SimpleTextField from "../../../../genericComponents/simpleTextField/SimpleTextField";
import SimpleDateField from "../../../../genericComponents/simpleTextField/SimpleDateField";
import SimpleTextAreaField from "../../../../genericComponents/simpleTextField/SimpleTextAreaField";
import SimpleThemedButton from "../../../../genericComponents/simpleTextField/SimpleThemedButton";
import { useUser } from "../../../../../../context/UserContext";
import {
  addContactsToCampaign,
  changeCampaignDate,
  createCampaign,
  nurtureContactSearchSave,
  userClientData,
} from "../../../../../../services/iqApiV2";
import { AccountListContext } from "../../../../../../context/AccountListContext";
import SearchOrAddDropdown from "../NurtureCampaignContact/SearchOrAddDropdown";
import { fetchAccountInfo } from "../../../../../../services/accIqService";
import { useDispatch, useSelector } from "react-redux";
import { fetchOpportunitiesRequest } from "../../../../../../store/features/actions/opportunities/opportunitesActions";
import { fetchWinOpportunitiesRequest } from "../../../../../../store/features/actions/opportunities/winOpportunitiesActions";
import { resetAllOppsReducer } from "../../../../../../store/features/actions/commonActions";
import * as FeatherIcon from "react-feather";
import { FetchAutoNurtureRequest } from "../../../../../../store/features/actions/autoNurture/autoNurtureActions";
import { parseContact, STEP_IDS } from "../../../../../../utilities/uiUtils";
import WarningForNurture from "../WarningForNurture";
import GenericBanner from "../../../../genericComponents/uiElements/GenericBanner";

function formatDateToYMD(date) {
  if (!date) return "";
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months start at 0
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

function campaignReducer(state, action) {
  switch (action.type) {
    case "SET_CAMPAIGN_INIT_FIELDS":
      return { ...state, [action.field]: action.value };
    default:
      return state;
  }
}

function NurtureCampaignInitComp({
  stepDispatch = () => {},
  stepId,
  setCurrentCampDetails,
  setCurrentStepIndex = () => {},
  currentCampDetails,
  setDomain,
  domain,
  newFlow,
  setNewFlow,
  prefilDataPerOpp = () => {},
  selectedCompanies,
  setSelectedCompanies = () => {},
  movingToAN = false,
  setShowMoreModalForAn = () => {},
  movingToANPostAction = async() => {},
  selectedContacts,
  noOppRefresh=false,
  productsList, setProducts,
  pageType="AUTO_NURTURE"
}) {
    
  
  const { opportunitesData, opportunitesLoading } = useSelector(
    (state) => state.opportunitiesReducer
  );
  const { winOpportunitesData, winOpportunitesLoading } = useSelector(
    (state) => state.winOpportunitiesReducer
  );

  const [filterOptions, setFilterOptions] = useState([]);

  useEffect(() => {
    if (opportunitesData || winOpportunitesData) {
      setFilterOptions([...opportunitesData, ...winOpportunitesData]);
    }
  }, [opportunitesData,winOpportunitesData]);
  const mapToOption = (arr) => arr.map((val) => ({ label: val, value: val }));
  const { user } = useUser();
  const lazyInit = () => ({
    campaignName: currentCampDetails?.campaignName ?? "",
    startDate: currentCampDetails?.startDate
      ? new Date(currentCampDetails.startDate)
      : new Date(),
    context: currentCampDetails?.campaignContext ?? "",
    minutes: 5,
    daysFrequency: 3,
    emailGenerationCount:currentCampDetails?.emailGenerationCount??""
  });

  const { allAccounts } = useContext(AccountListContext);
  const [domainLoading, setDomainLoading] = useState(false);

  const [selectedProducts, setSelectedProducts] = useState(
    currentCampDetails?.products || []
  );
  const [selectedOpp, setSelectedOpp] = useState();
  const [isContinueDisabled,setIsContinueDisabled]=useState(false);
  const [submitInProgress, setSubmitInProgress] = useState(false);
  const [state, dispatch] = useReducer(campaignReducer, null, lazyInit);
  const reduxDispatch = useDispatch();


  useEffect(() => {
   async function fetchDomain() {
      if (!selectedCompanies || selectedCompanies.length === 0) return;
      try {
        if (!movingToAN) {
           reduxDispatch(resetAllOppsReducer());
        }
       
        setDomainLoading(true);
        const response = await fetchAccountInfo(selectedCompanies);
        if (response?.organization_website) {
          setDomain(response.organization_website);
          const clientName = user?.company_name;
           if(!noOppRefresh){
          reduxDispatch(
            fetchOpportunitiesRequest({
              clientName,
              accountName: selectedCompanies,
              userId: user?.id,
              type: "spot",
            })
          );
          reduxDispatch(
            fetchWinOpportunitiesRequest({
              clientName,
              accountName: selectedCompanies,
              userId: user.id,
              type: "win",
            })
          );
        }
          setDomainLoading(false);
        }
      } catch (err) {
        setDomainLoading(false);
        console.error("Error fetching domain for account:", err);
      }
    }

    fetchDomain();

    return () => {
      console.log("clearup")
      if (!movingToAN) {
        reduxDispatch(resetAllOppsReducer());
      }
      
    };
}, [selectedCompanies]);

  useEffect(() => {
    if (currentCampDetails?.campaignName) {
      dispatch({
        type: "SET_CAMPAIGN_INIT_FIELDS",
        field: "campaignName",
        value: currentCampDetails.campaignName,
      });
    }
    if (currentCampDetails?.startDate) {
      dispatch({
        type: "SET_CAMPAIGN_INIT_FIELDS",
        field: "startDate",
        value: new Date(currentCampDetails.startDate),
      });
    }
    if (currentCampDetails?.campaignContext) {
      dispatch({
        type: "SET_CAMPAIGN_INIT_FIELDS",
        field: "context",
        value: currentCampDetails.campaignContext,
      });
    }
    setSelectedCompanies(currentCampDetails?.account);
    setSelectedProducts(currentCampDetails?.products || []);
  }, [currentCampDetails]);

  useEffect(() => {
    async function fetchClientData() {
      try {
        const userId = user?.id; // ensure this is set
        const clientName = user?.company_name;
        const currentRole = user?.role_key || "CLIENT"; // or get from auth

        if (!userId || !clientName) {
          console.warn("Missing userId or clientName");
          return;
        }

        const data = await userClientData(userId, clientName, currentRole);
        if (Array.isArray(data?.products)) {
          const seen = new Set();
          const productsFormatted = data.products
            .filter(item => {
              if (seen.has(item?._id)) return false; // duplicate -> skip
              seen.add(item?._id);
              return true;
            })
            .map(item => ({
              _id: item?._id,
              name: item?.product_name,
              description: item?.product_description
            }));

          setProducts(productsFormatted);
        }
        else {
          console.warn("Unexpected product structure:", data);
          setProducts([]);
        }
      } catch (error) {
        console.error("Failed to fetch client data:", error);
      }
    }

    fetchClientData();
  }, []);
  const handleCampaignInit = async () => {
    try {
      setSubmitInProgress(true);
      const dataObj = {
        title: state.campaignName,
        start_date: formatDateToYMD(state.startDate),
        context: state.context,
        time_gap: state.minutes,
        user_id: user?.id,
        user_name: user?.firstname + " " + user?.lastname,
        user_email: user?.email,
        client: user?.company_name,
        account: selectedCompanies,
        products: selectedProducts,
        campaignId: currentCampDetails?.campaignId,
        opportunity_id:currentCampDetails?.opportunityId,
        page_type:pageType,
        email_generation_count:state?.emailGenerationCount
      };
      const resp = await createCampaign(dataObj);
      if ((resp.status == 200 || resp?.success) && resp?.campaign_id) {
        setShowMoreModalForAn(false);
        setCurrentCampDetails({
          campaignName: state.campaignName,
          campaignContext: state.context,
          campaignId: resp?.campaign_id,
          account: selectedCompanies,
          startDate: state?.startDate,
          daysFrequency: state?.daysFrequency,
          products: selectedProducts,
        });
        console.log("newFlow",newFlow)
        if (selectedContacts?.length ) {
           await addContactsToCampaign(
                    resp?.campaign_id,
                    (selectedContacts ?? []).map(parseContact),
                    {domain}
                  )
        }
        debugger
        const searchList = {
          domain: domain, // https://www.marketsandmarkets.com/
          currentStepId: STEP_IDS.CAMPAIGN_INIT,
        };

        await nurtureContactSearchSave(
          resp?.campaign_id,
          searchList
        ); 
       
        // await movingToANPostAction(resp?.campaign_id);
        stepDispatch({ type: "MARK_COMPLETED", payload: stepId });
        setCurrentStepIndex((prev) => prev + 1);
        setSubmitInProgress(false);
        reduxDispatch( FetchAutoNurtureRequest({
                    clientName: null,
                    accountName: null,
                    userId: user?.id,
                  }));
      }
    } catch (error) {
      setSubmitInProgress(false);
    }
  };


   const handleCampaignInitFromOpp = async () => {
    try {
      setSubmitInProgress(true);
      const dataObj = {
        title: state.campaignName,
        start_date: formatDateToYMD(state.startDate),
        context: state.context,
        time_gap: state.minutes,
        user_id: user?.id,
        user_name: user?.firstname + " " + user?.lastname,
        user_email: user?.email,
        client: user?.company_name,
        account: selectedCompanies,
        products: selectedProducts,
        campaignId: currentCampDetails?.campaignId,
        opportunity_id:currentCampDetails?.opportunityId,
        page_type :"MAXIMIZE_PIPE",
        email_generation_count:state?.emailGenerationCount
      };
      const resp = await createCampaign(dataObj);
      if ((resp.status == 200 || resp?.success) && resp?.campaign_id) {
        setShowMoreModalForAn(false);
        setCurrentCampDetails({
          campaignName: state.campaignName,
          campaignContext: state.context,
          campaignId: resp?.campaign_id,
          account: selectedCompanies,
          startDate: state?.startDate,
          daysFrequency: state?.daysFrequency,
          products: selectedProducts,
        });

        await movingToANPostAction(resp?.campaign_id);

        setSubmitInProgress(false);
      }
    } catch (error) {
      setSubmitInProgress(false);
    }
  };

  console.log("selectedOpp", selectedOpp);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
      <span
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <span
          style={{
            display: "block",
            justifyContent: "flex-start",
            gap: "5.5rem",
            width: "100%",
          }}
        >
          <span
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              width: "35%",
            }}
          >
            {!movingToAN && (
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                <label className="nccs-field mb-4">
                  <span className="nccs-label stf-label ">
                    Target Account
                  </span>
                  <SearchOrAddDropdown
                    placeholder="Select Any one Account"
                    options={mapToOption([
                      ...new Set(allAccounts.map((acc) => acc.name)),
                    ])}
                    value={selectedCompanies}
                    onChange={setSelectedCompanies}
                    mode="single"
                    showCount={false}
                    className="stf-input"
                    searchMode="search-only"
                  />
                </label>
              </span>
            )}
            {newFlow && (
              <>
                {" "}
                {!movingToAN && (
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      marginBottom: "1rem",
                    }}
                  >
                    <SimpleTextField
                      value={state.campaignName}
                      setValue={(e) => {
                        dispatch({
                          type: "SET_CAMPAIGN_INIT_FIELDS",
                          field: "campaignName",
                          value: e.target.value,
                        });
                      }}
                    />
                  </span>
                )}
                <span
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    marginBottom: "1.5rem",
                  }}
                >
                  <label className="nccs-field">
                    <span className="nccs-label stf-label">
                      What Are You Selling ?
                    </span>
                    <span
                      className="what_selling_wrapper"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "1rem",
                        position: "relative",
                      }}
                    >
                      <SearchOrAddDropdown
                        placeholder="Choose One or More Products"
                        options={productsList}
                        value={selectedProducts}
                        onChange={setSelectedProducts} // placeholder text
                        mode="multiple"
                        showCount={false}
                        noEditPlaceHolder={true}
                        valueKey="name"
                        labelKey="name"
                        returnType="object"
                        searchMode="search"
                      />

                      <div className="selected_count">
                        {selectedProducts?.length > 0 && (
                          <>{selectedProducts?.length} Selected</>
                        )}
                      </div>
                    </span>
                  </label>
                </span>

                <label className="nccs-field">
                  <span className="nccs-label stf-label">
                    Number of emails to generate per contact
                  </span>
                  <SearchOrAddDropdown
                    placeholder="e.g, 3"
                    options={[
                      { label: 1, value: 1 },
                      { label: 2, value: 2 },
                      { label: 3, value: 3 },
                      // { label: 4, value: 4 },
                      // { label: 5, value: 5 },
                    ]}
                    value={state.emailGenerationCount}
                    onChange={(e) => {
                      dispatch({
                        type: "SET_CAMPAIGN_INIT_FIELDS",
                        field: "emailGenerationCount",
                        value: e,
                      });
                    }}
                    mode="single"
                    showCount={false}
                    returnType="value"
                    labelKey="label"
                    valueKey="value"
                    searchMode="search-only"
                  />
                </label>
                <span
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center", 
                    justifyContent: "flex-start",
                    gap: "1rem", 
                    marginBottom: "1rem",
                    marginTop: "1rem",
                  }}
                >
                  <SimpleDateField
                    disablePastDates={true}
                    label="Campaign Start Date"
                    labelPosition="top-left"
                    value={state.startDate}
                    onChange={async(val) => {
                      dispatch({
                        type: "SET_CAMPAIGN_INIT_FIELDS",
                        field: "startDate",
                        value: val,
                      });

                      if (currentCampDetails?.campaignId) {
                        await changeCampaignDate(val,currentCampDetails?.campaignId, user?.id)
                        setCurrentCampDetails((prev)=>({...prev,startDate:formatDateToYMD(new Date(val))}))
                      }
                    }}
                    minDate={new Date(2020, 0, 1)}
                    maxDate={new Date(2030, 11, 31)}
                    disableWeekends
                    customWidth="100%"
                  />
                 {formatDateToYMD(new Date(state.startDate))<formatDateToYMD(new Date()) &&  <GenericBanner
                    type="error"
                    message="Date cannot be less than today"
                  />}
                </span>
              </>
            )}
          </span>
          {newFlow && !movingToAN && (
            <span style={{ marginTop: "2rem" }}>
              {" "}
              <SimpleTextAreaField
                label="Campaign Context"
                placeholder="Describe the purpose and tone for this campaign…"
                rows={5}
                value={state.context}
                onChange={(e) =>
                  dispatch({
                    type: "SET_CAMPAIGN_INIT_FIELDS",
                    field: "context",
                    value: e.target.value,
                  })
                }
                customWidth="100%"
              />
            </span>
          )}
        </span>
        {!newFlow && (
          <>
          <WarningForNurture accountName={selectedCompanies} clientName={user?.company_name} oppId={selectedOpp?._id} setIsContinueDisabled={setIsContinueDisabled}/>
            {!selectedCompanies && (
              <div className="nccs-helper-text">
                <FeatherIcon.Info size={14} style={{ marginRight: "0.4rem" }} />
                Please select an account to continue
              </div>
            )}
            <div
              className={`nccs-pricing ${
                !selectedCompanies ? "nccs-disabled" : ""
              }`}
            >
              {/* Left Card */}
              <div className="nccs-card nccs-card--blue">
                <div className="nccs-card-header">
                  <span className="nccs-logo-dot green_title_dot"></span>
                  <h3 className="nccs-title green_title">
                    Create New Campaign
                  </h3>
                </div>

                <p className="nccs-subtitle">Kick off a fresh nurture flow</p>

                <ul className="nccs-list">
                  <li>Define campaign basics</li>
                  <li>Pick audiences &amp; timing</li>
                  <li>Generate email templates</li>
                </ul>

                <div className="nccs-cta">
                  <SimpleThemedButton
                    buttonText="Create Campaign"
                    btnDisabled={!selectedCompanies}
                    onBtnClick={(e) => {
                      e.preventDefault();
                      setNewFlow(true);
                    }}
                  />
                </div>
              </div>

              {/* Right Card */}
              <div className="nccs-card nccs-card--peach">
                <div className="nccs-card-header">
                  <span className="nccs-logo-dot blue_title"></span>
                  <h3 className="nccs-title blue_title">
                    Select an Opportunity
                  </h3>
                </div>

                <p className="nccs-subtitle">Pick an opportunity to continue</p>

                <ul className="nccs-list">
                  <li>Auto-populate context</li>
                </ul>

                <div className="nccs-field">
                  <SearchOrAddDropdown
                    placeholder="Select an Opportunity"
                    options={filterOptions}
                    value={selectedOpp}
                    onChange={setSelectedOpp}
                    mode="single"
                    showCount={false}
                    returnType="object"
                    labelKey="opportunity_name"
                    valueKey="opportunity_id"
                    searchMode="search-only"
                  />
                </div>

                <div className="nccs-cta">
                  <SimpleThemedButton
                    buttonText="Continue"
                    btnDisabled={!selectedOpp || isContinueDisabled}
                    isLoading={
                      domainLoading ||
                      opportunitesLoading ||
                      winOpportunitesLoading
                    }
                    loaderTxt="Getting Opportunities"
                    onBtnClick={(e) => {
                      e.preventDefault();

                      prefilDataPerOpp(selectedOpp);
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </span>

      {!movingToAN ? (
        <div
          style={{
            position: "fixed",
            width: "100%",

            zindex: "1000",
            borderTop: "1px solid #E2E8F0",
            right: "0rem",
            bottom: "0rem",
            padding: "0.5rem",

            backgroundColor: "#F2F6FB",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <SimpleThemedButton
            buttonText="Proceed To Contact Selection ->"
            onBtnClick={handleCampaignInit}
            isLoading={submitInProgress}
            btnDisabled={
              !state.campaignName ||
              !state.startDate ||
              formatDateToYMD(new Date(state.startDate))<formatDateToYMD(new Date())||
              !state?.emailGenerationCount ||
              !selectedCompanies?.length ||
              !selectedProducts?.length ||
              submitInProgress
            }
          />
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            position: "fixed",
            bottom: 0,
            width: "100%",
            left: 0,
            padding: "0.5rem",
            backgroundColor: "rgb(242, 246, 251)",
          }}
        >
          <SimpleThemedButton
            buttonText="Proceed To Contact Selection ->"
            loaderTxt="Generating Personalised Emails"
            onBtnClick={handleCampaignInitFromOpp}
            isLoading={submitInProgress}
            btnDisabled={
              !state.campaignName ||
              !state.startDate ||
              formatDateToYMD(new Date(state?.startDate))<formatDateToYMD(new Date())||
              !state?.context ||
              !state?.emailGenerationCount ||
              !selectedCompanies?.length ||
              !selectedProducts?.length ||
              submitInProgress
            }
          />
        </div>
      )}
    </div>
  );
}

export default NurtureCampaignInitComp;
